import React from "react";
import Header from "@/components/layout/Header";

export default function DashboardLayout({ children }) {
  return (
    <div className="min-h-screen bg-slate-50 overflow-x-hidden">
      <Header />
      <main className="pt-24 pb-16">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-10">{children}</div>
      </main>
    </div>
  );
}
